import { Layout } from "../../components/Layout";
import { useEffect, useState } from "react";
import { BookingService } from "../../services/Booking/BookingService";
import { Language } from "../../language/English";
import Loader from "../../components/Layout/Loader";
import Notification from "../../services/Notification/Notification";
import Logger from "../../services/Logger/Logger";
import { BookingPojo } from "../../services/Booking/BookingPojo/BookingPojo";
import IndividualBooking from "./IndividualBooking";
import AllBookings from "./AllBookings";
import { useParams, useSearchParams } from "react-router-dom";
import { BOOKING_BUSINESS_ID_QUERY_PARAM } from "../../services/Booking/BookingConstant";

const Bookings = () => {
    const [bookings, setBookings] = useState<BookingPojo[]>([]);
    const [showLoader, setShowLoader] = useState<boolean>(false);

    const { bookingId: routeBookingId } = useParams<{ bookingId?: string }>();
    const [searchParams] = useSearchParams();

    const notification = new Notification();
    const logger = new Logger;

    const mapBookingDetailsToBookingPojo = (bookingDetails: any): BookingPojo | null => {
        if (!bookingDetails || typeof bookingDetails !== "object") {
            return null;
        }

        const serviceDetails = Array.isArray(bookingDetails.serviceDetails)
            ? bookingDetails.serviceDetails
            : (Array.isArray(bookingDetails.booking_services) ? bookingDetails.booking_services : []);

        const business = bookingDetails.business ?? {};
        const totalAmountRaw = bookingDetails.totalAmount;
        const totalAmountNumber = typeof totalAmountRaw === "number"
            ? totalAmountRaw
            : Number(String(totalAmountRaw ?? "").replace(/[^0-9.-]/g, ""));

        return {
            businessId: Number(bookingDetails.businessId ?? business.businessId ?? 0),
            name: bookingDetails.name ?? bookingDetails.guestName ?? "",
            title: bookingDetails.title ?? "",
            phoneCountryCode: Number(bookingDetails.phoneCountryCode ?? bookingDetails.countryCode ?? 0),
            phoneNumber: Number(bookingDetails.phoneNumber ?? 0),
            whatsappPhoneCountryCode: Number(bookingDetails.whatsappPhoneCountryCode ?? 0),
            whatsappPhoneNumber: Number(bookingDetails.whatsappPhoneNumber ?? 0),
            postCode: bookingDetails.postCode ?? "",
            countryId: Number(bookingDetails.countryId ?? 0),
            regionId: Number(bookingDetails.regionId ?? 0),
            addressLine1: bookingDetails.addressLine1 ?? business.addressLine1 ?? "",
            addressLine2: bookingDetails.addressLine2 ?? business.addressLine2 ?? "",
            bookingId: Number(bookingDetails.bookingId ?? 0),
            bookingDate: bookingDetails.bookingDate ?? "",
            bookingTime: bookingDetails.bookingTime ?? "",
            businessName: bookingDetails.businessName ?? business.name ?? "",
            businessAddress: bookingDetails.businessAddress ?? "",
            businessPhone: Number(bookingDetails.businessPhone ?? business.phoneNumber ?? 0),
            businessWhatsappNumber: Number(bookingDetails.businessWhatsappNumber ?? business.whatsappPhoneNumber ?? 0),
            guestName: bookingDetails.guestName ?? bookingDetails.name ?? "",
            numberOfGuest: Number(bookingDetails.numberOfGuest ?? bookingDetails.guestQuantity ?? 0),
            totalAmount: Number.isNaN(totalAmountNumber) ? 0 : totalAmountNumber,
            bookedOn: bookingDetails.bookedOn ?? "",
            status: Number(bookingDetails.status ?? 0),
            dateOfBooking: bookingDetails.dateOfBooking ?? "",
            creationDate: bookingDetails.creationDate ?? "",
            addressLine3: bookingDetails.addressLine3 ?? business.addressLine3 ?? "",
            url: bookingDetails.url ?? business.url ?? "",
            timeOfBooking: bookingDetails.timeOfBooking ?? "",
            serviceDetails,
        };
    };
    
    const fetchBookings = async(bookingId?: number, businessId?: number) => {
        try{
            const bookingService = new BookingService;
            if (bookingId) {
                const bookingById = await bookingService.getByBookingId(bookingId);
                if (bookingById) {
                    setBookings([bookingById]);
                } else {
                    setBookings([]);
                    notification.error(Language.BOOKING_NOT_FOUND_FOR_PROVIDED_BOOKING_ID);
                }
            } else if (businessId) {
                const response = await bookingService.getAllByBusinessId(businessId);
                if(response){
                    setBookings(response.bookings);
                } else {
                    notification.error(Language.CANNOT_LOAD_BUSINESSES_TECHNICAL_ERROR);
                }
            } else {
                const response = await bookingService.getAll();
                if(response){
                    setBookings(response.bookings);
                } else {
                    notification.error(Language.CANNOT_LOAD_BUSINESSES_TECHNICAL_ERROR);
                }
            }
            setShowLoader(false);
        } catch (e){
            notification.error(Language.SOMETHING_IS_WRONG);
            setShowLoader(false);
            logger.error(e);
        }
    }
    useEffect(() => {
        setShowLoader(true);
        const bookingIdFromQuery = searchParams.get("bookingId");
        const businessIdFromQuery = searchParams.get(BOOKING_BUSINESS_ID_QUERY_PARAM);
        const bookingIdRaw = routeBookingId ?? bookingIdFromQuery ?? undefined;
        const parsedBookingId = bookingIdRaw ? Number(bookingIdRaw) : undefined;
        const parsedBusinessId = businessIdFromQuery ? Number(businessIdFromQuery) : undefined;

        if (bookingIdRaw && (!parsedBookingId || Number.isNaN(parsedBookingId) || parsedBookingId < 1)) {
            setShowLoader(false);
            setBookings([]);
            notification.error(Language.BOOKING_ID_MUST_BE_A_POSITIVE_INTEGER);
            return;
        }

        if (businessIdFromQuery && (!parsedBusinessId || Number.isNaN(parsedBusinessId) || parsedBusinessId < 1)) {
            setShowLoader(false);
            setBookings([]);
            notification.error(Language.BUSINESS_ID_MUST_BE_A_POSITIVE_INTEGER);
            return;
        }

        fetchBookings(parsedBookingId, parsedBusinessId);
    }, [routeBookingId, searchParams]);
    return (
        <div>
            <Layout>
                { showLoader ? <Loader /> : null }
                <AllBookings >
                {
                    bookings.length > 0 && bookings.map( (bookings, index) => (
                        <IndividualBooking bookings={bookings} key={bookings.bookingId} count={index}/>
                    ))
                }
                </AllBookings>
        </Layout>
      </div>
    )
}
export default Bookings;